import React from "react";
import { Typography } from "@mui/material";

// A small uppercase group heading (STONE, COLOR, …) in the primary colour, above a group of
// SpecRows. Shared by every panel that describes a stone, so the heading reads the same everywhere.
const GroupTitle = ({ children }: { children: React.ReactNode }) => (
  <Typography
    sx={{
      fontSize: "0.6875rem",
      fontWeight: 500,
      letterSpacing: "0.08em",
      textTransform: "uppercase",
      color: "primary.main",
      mb: 1,
    }}
  >
    {children}
  </Typography>
);

export default GroupTitle;
